import { Container, Form, FormControl, InputGroup, Spinner, Table } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';
import { getSrikandiCommissions, useSrikandiUser } from '../../API';
import { ICommission, ISummarySale, IUser } from '../../@types';
import { useAuth } from '../../Context/AuthContext';
import { get, getDatabase, ref } from 'firebase/database';
import { firebaseApp } from '../../index';
import { useReactToPrint } from 'react-to-print';
import ReportSheet from './reportSheet';
import { Bonus } from './ExtraBonus';

const formatDate = (date: Date) => date.toISOString().slice(0, 10);

const Sales = () => {
  const [reportDate, setReportMonth] = useState(new Date());
  const [commissions, setCommissions] = useState<ICommission[]>([]);
  const [status, setStatus] = useState<'empty' | 'loading' | 'success' | 'error'>('empty');
  const [errorMessage, setErrorMessage] = useState('');
  const [sale, setSale] = useState(0);
  const [groupSale, setGroupSale] = useState(0);
  const [users, setUsers] = useState<any[]>([]);
  const [bonus, setbonus] = useState<Bonus[]>()
  const [children, setChildren] = useState<
    {
      user: IUser;
      summary: ISummarySale;
    }[]
  >([]);
  const { user: currentUser, dbUser } = useAuth();
  const user = useSrikandiUser(currentUser?.uid);
  const [selectedUser, setSelectedUser] = useState('');
  const fullSelectedUser = useSrikandiUser(selectedUser);
  const componentRef = useRef<any>();

  useEffect(() => {
    if (dbUser) {
      if (dbUser.role === 'admin') {
        const database = getDatabase(firebaseApp);
        const usersRef = ref(database, 'users');
        get(usersRef).then((usersSnapshot) => {
          let userList: any[] = [];
          usersSnapshot.forEach((userSnapshot) => {
            const userVal = userSnapshot.val();
            if (userVal && userVal.role !== 'deactivated') {
              userList = userList.concat({
                id: userSnapshot.key,
                ...userVal,
              });
            }
          });
          setUsers(
            userList.filter((user) => user.name).sort((a, b) => a.name.localeCompare(b.name)),
          );
        });
      } else {
        setUsers([
          {
            id: dbUser.id,
            email: dbUser.email,
            name: dbUser.name,
          },
        ]);
        setSelectedUser(dbUser.id);
      }
    }
  }, [dbUser]);

  // useEffect(() => {
  //   if (!window.confirm('NOTE! This page is in ALPHA testing stage. By using this page, you acknowledge that the data displayed will not always be accurate.')) {
  //     navigate('/')
  //   }
  // }, [])

  useEffect(() => {
    if (selectedUser) {
      setStatus('loading');
      getSrikandiCommissions(selectedUser, formatDate(reportDate))
        .then((data) => {
          const { commissions, targetAchievedChildren, totalSales, totalGroupSales } = data;
          setStatus('success');
          setSale(totalSales);
          setGroupSale(totalGroupSales);
          setCommissions(commissions);
          setChildren(targetAchievedChildren);
        })
        .catch((err) => {
          setErrorMessage(err.message);
          setStatus('error');
        });

        const month = reportDate.getUTCMonth() + 1;
        const year = reportDate.getUTCFullYear();
        const database = getDatabase(firebaseApp);
        const bonusRef = ref(database, `extraBonus/${year}/${month}/${selectedUser}`);
        get(bonusRef).then((bonusSnapshot) => {
          setbonus(bonusSnapshot.val())
        });
    }
  }, [reportDate, selectedUser]);

  const handlePrinter = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleDownload = () => {
    const format = new Intl.DateTimeFormat('en-MY', { month: 'long', year: 'numeric' }).format;

    if (window.confirm(`Download selected month (${format(reportDate)}) report summary?`)) {
      window.open(
        // http://127.0.0.1:5001/sk-srikandi/asia-southeast1
        `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-srikandiCommissionSummary?date=${formatDate(
          reportDate,
        )}&secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  };

  const handleDownloadSrikandiReport = () => {
    const format = new Intl.DateTimeFormat('en-MY', { month: 'long', year: 'numeric' }).format;

    if (window.confirm(`Download selected month (${format(reportDate)}) report summary?`)) {
      window.open(
        `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-commissionSummarySrikandi?date=${formatDate(
          reportDate,
        )}&secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  };

  const handleDownloadSrikandiEmasReport = () => {
    const format = new Intl.DateTimeFormat('en-MY', { month: 'long', year: 'numeric' }).format;

    if (window.confirm(`Download selected month (${format(reportDate)}) report summary?`)) {
      window.open(
        `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-srikandiEmasCommissionSummary?date=${formatDate(
          reportDate,
        )}&secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  };

  const handleDownloadAll = () => {
    const format = new Intl.DateTimeFormat('en-MY', { month: 'long', year: 'numeric' }).format;

    if (window.confirm(`Download selected month (${format(reportDate)}) report details?`)) {
      window.open(
        `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-srikandiAllCommission?date=${formatDate(
          reportDate,
        )}&secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  };

  const handleCp58 = () => {
    if (window.confirm(`Download cp58?`)) {
      window.open(
        `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-downloadDataCp58?secret=QAoL5xN6Up`,
        // `http://127.0.0.1:5001/sk-srikandi/asia-southeast1/query-downloadDataCp58?secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  };

  if (!user) {
    return (
      <Container>
        <Spinner
          animation="border"
          role="status"
          className="text-center"
          style={{
            position: 'absolute',
            height: '80px',
            width: '80px',
            top: '50%',
            left: '50%',
            marginLeft: '-50px',
            marginTop: '-30px',
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  let totalOverrideCommission = 0;
  let totalProductCommission = 0;
  let totalBonusCommission = 0;
  let totalSalesCommission = 0;
  let totalCommissionAmount = 0;
  let otherCommission = 0;

  const topChildren = children.sort(
    (a, b) => parseFloat(b.summary.total_sale) - parseFloat(a.summary.total_sale),
  )[0];

  const handleSaleUserChange = (event: any) => {
    setSelectedUser(event.target.value);
    console.log(event.target.value);
  };

  return (
    <Container>
      <div style={{ width: '100%' }}>
        <div className=" centerItem">
          <h2 className="header ">Commission Report</h2>
          <br />
          <Form.Group className="mb-3" style={{ width: '50%' }}>
            <Form.Label htmlFor="outletSelect">
              <b className="smallTitle">Select User</b>
            </Form.Label>
            <InputGroup>
              <FormControl
                id="outletSelect"
                onChange={handleSaleUserChange}
                value={selectedUser}
                as="select"
                className="selectBox centerItem"
              >
                {users.map((e) => (
                  <option key={e.id} value={e.id}>{`${e.name} (${e.email})`}</option>
                ))}
              </FormControl>
            </InputGroup>
          </Form.Group>
          <br />
          <div>
            <button disabled={status !== 'success'} onClick={handlePrinter}>
              Print Report
            </button>
          </div>
          {dbUser?.role === 'admin' ? (
            <>
              <br />
              <div>
                <button onClick={handleCp58}>CP58</button>
              </div>
            </>
          ) : null}
          {dbUser?.role === 'admin' ? (
            <>
              <br />
              <div>
                <button onClick={handleDownload}>Download Report Summary</button>
              </div>
            </>
          ) : null}
          {dbUser?.role === 'admin' ? (
            <>
              <br />
              <div>
                <button onClick={handleDownloadSrikandiReport}>
                  Download Report Srikandi Summary
                </button>
              </div>
            </>
          ) : null}
          {dbUser?.role === 'admin' ? (
            <>
              <br />
              <div>
                <button onClick={handleDownloadSrikandiEmasReport}>
                  Download Report Srikandi Emas Summary
                </button>
              </div>
            </>
          ) : null}
          {dbUser?.role === 'admin' ? (
            <>
              <br />
              <div>
                <button onClick={handleDownloadAll}>Download All User Report Details</button>
              </div>
            </>
          ) : null}
          <div style={{ width: '100%', overflowX: 'auto' }}>
            {status === 'success' && (
              <ReportSheet
                ref={componentRef}
                children={children}
                fullSelectedUser={fullSelectedUser}
                bonus={bonus}
                users={users}
                commissions={commissions}
                groupSale={groupSale}
                sale={sale}
                totalCommissionAmount={totalCommissionAmount}
                setReportMonth={setReportMonth}
                totalProductCommission={totalProductCommission}
                totalOverrideCommission={totalOverrideCommission}
                totalSalesCommission={totalSalesCommission}
                reportDate={reportDate}
                totalBonusCommission={totalBonusCommission}
                otherCommission={otherCommission}
                className="page"
              />
            )}
            {status === 'loading' && (
              <div
                style={{
                  width: '100%',
                  height: '200px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Spinner
                  animation="border"
                  role="status"
                  className="text-center"
                  style={{
                    position: 'absolute',
                    height: '40px',
                    width: '40px',
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}
            {status === 'error' && (
              <div
                style={{
                  width: '100%',
                  height: '200px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#ef4444',
                    color: 'white',
                    padding: '10px',
                    borderRadius: 10,
                  }}
                >
                  {errorMessage}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Sales;
